import React from 'react';
import PropTypes from 'prop-types';
import '../../less/popup.less';


const Popup = ({ show, topBarTitle, clsName, children, onClose }) => (
  <div className={`popup ${show ? 'show' : 'hide'} ${clsName}`}>
    <div className="popup-inner">
      <div className="top-bar">
        <div>{ topBarTitle }</div>
        <div className="ui-dialog-titlebar-close ui-corner-all" onClick={onClose}>
          <span className="ui-icon ui-icon-closethick">close</span>
        </div>
      </div>
      { children }
    </div>
  </div>
);

Popup.defaultProps = {
  show: false,
  clsName: '',
  topBarTitle: '',
  children: null,
};

Popup.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  clsName: PropTypes.string,
  topBarTitle: PropTypes.string,
  children: PropTypes.any,
};

export default Popup;



/** WEBPACK FOOTER **
 ** ./src/components/common/Popup.jsx
 **/